import React from "react"
import PropTypes from "prop-types"
import { compose } from "redux"
import { connect } from "react-redux"
import "./index.less"
import { Switch, Spin } from "antd"
import { createStructuredSelector } from "reselect"
import { makeTwoFactorAuthActive } from "./selectors"
import reducer from "./reducer"
import saga from "./saga"
import { getTwoFactorAuthWatcher, putTwoFactorAuthWatcher } from "./actions"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import Loader from "components/Loader"

export class Security extends React.Component {
  componentDidMount() {
    this.props.getTwoFactorAuthWatcher()
  }

  render() {
    return (
      <div className="container-security">
        <div className="container-security-description">
          Configura la seguridad al iniciar sesión para cada tipo de usuario
          dentro de la plataforma.
        </div>
        {this.props.security.isLoading ? (
          <Loader />
        ) : (
          <div className="container-security-content">
            <div className="container-security-option">
              <Switch
                checked={this.props.security.twoFactorAuthActive}
                className="container-security-option-switch"
                onChange={(e) =>
                  this.props.putTwoFactorAuthWatcher({
                    two_factor_auth: e,
                  })
                }
                loading={this.props.security.loadSwitch}
              />

              <div className="container-security-option-title">
                <strong>Autenticación de dos factores</strong>
              </div>
              <div className="container-security-option-description">
                Medida de protección adicional para garantizar que sólo el
                usuario pueda entrar a su cuenta. Al iniciar sesión, se le
                enviará un código a su correo que deberá ingresar en la
                plataforma para continuar.
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

Security.propTypes = {
  dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  security: makeTwoFactorAuthActive(),
})

function mapDispatchToProps(dispatch) {
  return {
    getTwoFactorAuthWatcher: (params) =>
      dispatch(getTwoFactorAuthWatcher(params)),
    putTwoFactorAuthWatcher: (params) =>
      dispatch(putTwoFactorAuthWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "security", reducer })
const withSaga = injectSaga({ key: "security", saga })

export default compose(withReducer, withSaga, withConnect)(Security)
